import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { getCookie } from '@beef/utils';
import { useMutableRef } from '@carnica/utils/hooks';
import { setStageAnswerMes } from "../../../../../analytics";
import { CAPTCHA_ACCESS_COOKIE_NAME, CAPTCHA_BLOCKED_TIMEOUT_KEY } from "../../../../../config";
import { useOnlineStatus } from "../../../../../lib";
import { FSMStages } from "../../types";
import { DEFAULT_TIMEOUT_TIME, isInvalidChangeAction } from "./helper";
import { useFSMBlocker } from "../useFSMBlocker";
export var useFSMOperations = function useFSMOperations(params) {
  var _params$blockedTimeou = params.blockedTimeout,
    blockedTimeout = _params$blockedTimeou === void 0 ? DEFAULT_TIMEOUT_TIME : _params$blockedTimeou,
    isOpen = params.isOpen,
    zoneType = params.zoneType,
    baseUrl = params.baseUrl;
  var _useState = useState(FSMStages.IDLE),
    _useState2 = _slicedToArray(_useState, 2),
    stage = _useState2[0],
    setStage = _useState2[1];
  var stageRef = useMutableRef(stage);
  var blockReachedHandlersRef = useRef({});
  var isOpenRef = useMutableRef(isOpen);
  var isOnline = useOnlineStatus();
  var onBlockReached = function onBlockReached() {
    setStage(FSMStages.CAPTCHA_NEEDED);
    Object.keys(blockReachedHandlersRef.current).forEach(function (key) {
      blockReachedHandlersRef.current[key]();
    });
  };
  var addReachedHandler = function addReachedHandler(type, func) {
    blockReachedHandlersRef.current[type] = func;
  };
  var activateBlocking = useFSMBlocker({
    onReached: onBlockReached,
    onActivate: function onActivate() {
      setStage(FSMStages.BLOCKED);
      stageRef.current = FSMStages.BLOCKED;
    },
    zoneType: zoneType
  });
  var changeStage = useCallback(function (newStage) {
    var blockTime = getCookie(CAPTCHA_BLOCKED_TIMEOUT_KEY);
    if (isInvalidChangeAction({
      stage: stageRef.current,
      newStage: newStage,
      authZone: zoneType,
      blockTime: blockTime,
      isOpen: isOpenRef.current
    })) {
      return {
        status: 'error'
      };
    }
    if (newStage === FSMStages.CAPTCHA_NEEDED) {
      setStageAnswerMes();
    }
    if (newStage === FSMStages.BLOCKED) {
      activateBlocking({
        timeout: blockedTimeout
      });
    }
    setStage(newStage);
    return {
      status: 'ok'
    };
  }, [stage, blockedTimeout]);
  var options = useMemo(function () {
    return {
      blockedTimeout: blockedTimeout
    };
  }, [blockedTimeout]);
  var updateStage = function updateStage() {
    if (!isOnline) {
      // TODO: экран ошибки
      setStage(FSMStages.ERROR);
      return;
    }
    if (!isOpen) {
      changeStage(FSMStages.IDLE);
      return;
    }
    if (!baseUrl) {
      changeStage(FSMStages.ERROR);
      return;
    }
    if (zoneType === 'authorized' || getCookie(CAPTCHA_ACCESS_COOKIE_NAME)) {
      changeStage(FSMStages.LOAD_DATA);
      return;
    }
    changeStage(FSMStages.CAPTCHA_NEEDED);
  };
  useEffect(updateStage, [zoneType, isOpen]);
  return {
    stage: stage,
    changeStage: changeStage,
    options: options,
    addReachedHandler: addReachedHandler
  };
};